<template>
  <transition name="ai-fade">
    <div v-if="visible" class="ai-typing-row">
      <div class="ai-avatar nixia-avatar">
        <i class="fa-duotone fa-solid fa-microchip-ai"></i>
      </div>
      <div class="ai-typing-bubble">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "AiTypingIndicator",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ai-typing-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ai-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #577696;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}

.ai-typing-bubble {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 14px 16px;
  background: #f1f5f9;
  border-radius: 14px;
  border-bottom-left-radius: 4px;
  min-width: 60px;
}

.ai-typing-bubble span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #94a3b8;
  animation: ai-blink 1.2s infinite ease-in-out;
  display: inline-block;
}

.ai-typing-bubble span:nth-child(2) {
  animation-delay: 0.2s;
}

.ai-typing-bubble span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes ai-blink {
  0%, 80%, 100% { opacity: 0.2; transform: scale(0.85); }
  40%           { opacity: 1;   transform: scale(1.15); }
}

.ai-fade-enter-active,
.ai-fade-leave-active {
  transition: opacity 0.2s;
}

.ai-fade-enter,
.ai-fade-leave-to {
  opacity: 0;
}

.dark-theme .ai-typing-bubble {
  background: #2d3748;
}
</style>
